import React, { Component } from 'react';
import HeaderCenter from './HeaderCenter';
import HeaderRightNav from './HeaderRightNav';
import HeaderLeftNav from './HeaderLeftNav';

class Header extends Component {
  render() {
    return (
        <header className="header">
          <HeaderLeftNav/>
          <HeaderRightNav/>
          <HeaderCenter/>
        </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js